export enum TargetType {
  BRAND_TO_CUSTOMER = 'BRAND_TO_CUSTOMER',
  BRAND_TO_SALES_REPRESENTATIVE = 'BRAND_TO_SALES_REPRESENTATIVE',
  STORE_TO_ITSELF = 'STORE_TO_ITSELF',
}

export enum TargetUnit {
  GROSS_MONEY = 'GROSS_MONEY',
  NET_MONEY = 'NET_MONEY',
  QUANTITY = 'QUANTITY',
}

export enum TargetPeriodType {
  DATE_RANGE = 'DATE_RANGE',
  ORDER_COLLECTION = 'ORDER_COLLECTION',
  PRODUCT_COLLECTION = 'PRODUCT_COLLECTION',
}

export enum TargetRecipientType {
  CUSTOMER = 'CUSTOMER',
  SALES_REPRESENTATIVE = 'SALES_REPRESENTATIVE',
}

export enum TargetStatus {
  SUGGESTED = 'SUGGESTED',
  DRAFT = 'DRAFT',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CLOSED_WON = 'CLOSED_WON',
  CLOSED_LOST = 'CLOSED_LOST',
  CANCELED = 'CANCELED',
}

export enum TargetLossReason {
  UNATTRACTIVE_COLLECTION = 'UNATTRACTIVE_COLLECTION',
  UNATTRACTIVE_BUSINESS_POLICY = 'UNATTRACTIVE_BUSINESS_POLICY',
  UNATTRACTIVE_PRICE = 'UNATTRACTIVE_PRICE',
  HIGH_STOCK = 'HIGH_STOCK',
  BLOCKED_CUSTOMER = 'BLOCKED_CUSTOMER',
  BILLING_ISSUES = 'BILLING_ISSUES',
  REPLACEMENT_BY_FRANCHISE_OR_STORE = 'REPLACEMENT_BY_FRANCHISE_OR_STORE',
  REPLACEMENT_BY_ANOTHER_RETAILER = 'REPLACEMENT_BY_ANOTHER_RETAILER',
  WEBSITE_CONFLICT = 'WEBSITE_CONFLICT',
  WILL_BUY_NEXT_COLLECTION = 'WILL_BUY_NEXT_COLLECTION',
  CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP = 'CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP',
  CNPJ_CHANGE = 'CNPJ_CHANGE',
  STORE_CLOSED = 'STORE_CLOSED',
  NATURAL_DISASTERS = 'NATURAL_DISASTERS',
}

export enum TargetCriterionType {
  AVAILABILITY = 'AVAILABILITY',
  DELIVERY_WINDOW = 'DELIVERY_WINDOW',
  PRODUCT_CLASSIFICATION = 'PRODUCT_CLASSIFICATION',
  CUSTOMER_CLASSIFICATION = 'CUSTOMER_CLASSIFICATION',
}

export enum TargetBreakdownType {
  CLASSIFICATION_TECEO = 'CLASSIFICATION_TECEO',
  BRAND_CATEGORY = 'BRAND_CATEGORY',
  BRAND_SUB_CATEGORY = 'BRAND_SUB_CATEGORY',
  BRAND_CLASSIFICATION = 'BRAND_CLASSIFICATION',
  DELIVERY_WINDOW = 'DELIVERY_WINDOW',
}

export enum TargetStatusGroup {
  DRAFTS = 'DRAFTS',
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
}

export enum TargetAttributeBase {
  TECEO = 'TECEO',
  BRAND = 'BRAND',
}

export enum FormulaOperator {
  ADD = '+',
  SUBTRACT = '-',
  MULTIPLY = '*',
  DIVIDE = '/',
}

export type TargetMetric = string;

export interface TargetMethodOperation {
  operator: FormulaOperator;
  left: TargetMethodExpression;
  right: TargetMethodExpression;
}

export type TargetMethodExpression = TargetMetric | TargetMethodOperation;

export enum TeceoDimensionCode {
  BRAND = 'BRAND',
  CATEGORIA = 'CATEGORIA',
  COR = 'COR',
  GENERO = 'GENERO',
  MATERIAL_ROUPA = 'MATERIAL_ROUPA',
}

export enum TargetParameterType {
  PERIOD = 'PERIOD',
  GROWTH = 'GROWTH',
  TARGET_COVERAGE = 'TARGET_COVERAGE',
}

export enum Metric {
  SELLOUT_NET_VALUE = 'SELLOUT_NET_VALUE',
  SELLOUT_GROSS_VALUE = 'SELLOUT_GROSS_VALUE',
  SELLOUT_DISCOUNT_VALUE = 'SELLOUT_DISCOUNT_VALUE',
  SELLOUT_UNITS = 'SELLOUT_UNITS',
  SELLOUT_SALES_COUNT = 'SELLOUT_SALES_COUNT',
  SELLOUT_UNITS_WITH_SELLIN_MATCH = 'SELLOUT_UNITS_WITH_SELLIN_MATCH',
  SELLOUT_AVERAGE_NET_PRICE = 'SELLOUT_AVERAGE_NET_PRICE',
  SELLOUT_AVERAGE_GROSS_PRICE = 'SELLOUT_AVERAGE_GROSS_PRICE',
  SELLOUT_UNITS_PER_SALE = 'SELLOUT_UNITS_PER_SALE',
  SELLOUT_DISCOUNT_RATE = 'SELLOUT_DISCOUNT_RATE',
  COST_OF_GOODS_SOLD = 'COST_OF_GOODS_SOLD',
  SELLOUT_NET_VALUE_WITH_COST = 'SELLOUT_NET_VALUE_WITH_COST',
  GROSS_MARGIN = 'GROSS_MARGIN',
  MARKUP = 'MARKUP',
  CURRENT_STOCK_UNITS = 'CURRENT_STOCK_UNITS',
  MATCHED_SELLIN_UNITS = 'MATCHED_SELLIN_UNITS',
  MATCHED_SELLIN_NET_VALUE = 'MATCHED_SELLIN_NET_VALUE',
  MATCHED_SELLIN_BACKLOG_UNITS = 'MATCHED_SELLIN_BACKLOG_UNITS',
  SELL_THROUGH = 'SELL_THROUGH',
  STOCK_TURNOVER = 'STOCK_TURNOVER',
  STOCK_COVERAGE_MONTHS = 'STOCK_COVERAGE_MONTHS',
  SELLIN_NET_VALUE = 'SELLIN_NET_VALUE',
  SELLIN_GROSS_VALUE = 'SELLIN_GROSS_VALUE',
  SELLIN_UNITS = 'SELLIN_UNITS',
  SELLIN_ORDERS_COUNT = 'SELLIN_ORDERS_COUNT',
  SELLIN_AVERAGE_NET_PRICE = 'SELLIN_AVERAGE_NET_PRICE',
  SELLIN_AVERAGE_GROSS_PRICE = 'SELLIN_AVERAGE_GROSS_PRICE',
  SELLIN_AVERAGE_ORDER_VALUE = 'SELLIN_AVERAGE_ORDER_VALUE',
  SELLIN_DISCOUNT_RATE = 'SELLIN_DISCOUNT_RATE',
  SELLIN_BACKLOG_UNITS = 'SELLIN_BACKLOG_UNITS',
  SELLIN_BACKLOG_NET_VALUE = 'SELLIN_BACKLOG_NET_VALUE',
  SELLIN_INVOICED_UNITS = 'SELLIN_INVOICED_UNITS',
  SELLIN_INVOICED_NET_VALUE = 'SELLIN_INVOICED_NET_VALUE',
  SELLIN_RESERVED_UNITS = 'SELLIN_RESERVED_UNITS',
  SELLIN_CANCELED_UNITS = 'SELLIN_CANCELED_UNITS',
  MATCHED_SELLOUT_NET_VALUE = 'MATCHED_SELLOUT_NET_VALUE',
  MATCHED_SELLOUT_GROSS_VALUE = 'MATCHED_SELLOUT_GROSS_VALUE',
  MATCHED_SELLOUT_UNITS = 'MATCHED_SELLOUT_UNITS',
  MATCHED_STOCK_UNITS = 'MATCHED_STOCK_UNITS',
  GROWTH = 'GROWTH',
  TARGET_COVERAGE = 'TARGET_COVERAGE',
  PERIOD_MONTHS = 'PERIOD_MONTHS',
}

export enum MetricScale {
  MONEY = 'MONEY',
  UNITS = 'UNITS',
  SALES = 'SALES',
  ORDERS = 'ORDERS',
  MONTHS = 'MONTHS',
  PERCENT = 'PERCENT',
  MULTIPLE = 'MULTIPLE',
  MONEY_PER_UNIT = 'MONEY_PER_UNIT',
  MONEY_PER_ORDER = 'MONEY_PER_ORDER',
  UNITS_PER_SALE = 'UNITS_PER_SALE',
  UNITS_PER_MONTH = 'UNITS_PER_MONTH',
}
